import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'delete-checklist-modal',
    templateUrl: './delete-checklist-modal.component.html',
    styleUrls: ['./delete-checklist-modal.component.scss'],
})
export class DeleteChecklistModalComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
